import type { RouteRecordRaw } from "vue-router";

export const checkoutRoutes: RouteRecordRaw = {
    path: '/checkout',
    redirect: '/checkout/queue',
    children: [
        {
            name: 'Check In / Checkout',
            path: '/checkout/queue',
            component: () => import('./queue/CheckoutQueue.vue')
        },
        {
            name: 'Checkout',
            path: '/checkout/:appointmentId',
            component: () => import('./details/CheckoutDetails.vue'),
            children: [
                {
                    name: 'details',
                    path: 'details',
                    component: () => import('./details/appointments/CheckoutAppointments.vue')
                },
                {
                    name: 'medical',
                    path: 'medical',
                    component: () => import('./details/medical/CheckoutMedical.vue')
                },
                {
                    name: 'financial',
                    path: 'financial',
                    component: () => import('./details/financial/CheckoutFinancial.vue')
                },
                {
                    name: 'idexx',
                    path: 'idexx',
                    component: () => import('./details/idexx/CheckoutIdexx.vue')
                },
                {
                    name: 'custom-fields',
                    path: 'custom-fields',
                    component: () => import('./details/custom-fields/CheckoutCustomFields.vue')
                }
            ]
        },
        {
            name: 'Online Appointments',
            path: 'online-appointments',
            component: () => import('./online-appointments/OnlineAppointments.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Checkout Quick Entry',
            path: 'quick-entry',
            component: () => import('./quick-entry/CheckoutQuickEntry.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Roster',
            path: 'roster',
            component: () => import('./roster/RosterPage.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Prescription Logs',
            path: 'prescription-logs',
            component: () => import('./prescription-logs/PrescriptionLogs.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Rechecks',
            path: 'recheck',
            component: () => import('./rechecks/RechecksPage.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Scheduler Logs',
            path: 'scheduler-logs',
            component: () => import('./scheduler-logs/SchedulerLogs.vue'),
            meta: { defaultLayout: true }
        },
        {
            name: 'Print / Email Paperwork',
            path: '/checkout/paperwork',
            component: () => import('../paperwork/PaperworkPage.vue'),
            meta: { defaultLayout: true }
        }
    ]
}